import { Box } from "@chakra-ui/react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import React from "react";

const GrubDropDown = (props) => {
    const commonStyle = {
        width: props.width || "100%",
        maxWidth: props.maxWidth,
        backgroundColor: "rgba(88, 129, 254, 0.05)",
        borderRadius: "0.625rem",
        fontSize: "0.94rem",
        fontWeight: 300,
        color: "#010048",
        height: props.height,
        border: "1px solid rgba(183, 183, 183, 0.12)",
    };

    const commonPanelStyle = {
        backgroundColor: "#F4F4F4",
        width: "inherit", // This will match parent width
        minWidth: "inherit", // Ensures minimum width matches parent
        borderRadius: "0.625rem",
        border: "1px solid rgba(183, 183, 183, 0.12)",
        margin: 0,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    };

    if (props.multiSelect) {
        return (
            <Box width={props.width || "100%"}>
                <MultiSelect
                    value={props.value}
                    onChange={props.onChange}
                    options={props.options}
                    optionLabel={props.optionLabel}
                    onBlur={props.onBlur}
                    onHide={props.onHide}
                    filter
                    placeholder={props.placeholder}
                    style={commonStyle}
                    panelStyle={commonPanelStyle}
                    filterInputAutoFocus={true}
                    filterPlaceholder={"Search"}
                    className={props.className}
                    maxSelectedLabels={props.maxSelectedLabels}
                    resetFilterOnHide={true}
                    disabled={props.disabled}
                />
            </Box>
        );
    } else {
        return (
            <Box width={props.width || "100%"}>
                <Dropdown
                    value={props.value}
                    onChange={(e) => props.onChange(e)}
                    options={props.options}
                    optionLabel={props.optionLabel}
                    placeholder={props.placeholder}
                    style={commonStyle}
                    panelStyle={commonPanelStyle}
                    filterInputAutoFocus={false}
                    filterPlaceholder={"Search"}
                    onBlur={props.onBlur}
                    className={props.className}
                    disabled={props.disabled}
                    resetFilterOnHide={true}
                    filter={props.filter}
                />
            </Box>
        );
    }
};
export default GrubDropDown;
